/**
 * @author Mevan Nirosh
 * @version 1.0
 * @since 6/19/2023
 */ 
export const RequestErrorHandeling = (
  error,
  setIserror,
  setErrorMessages,
  setIserrorShow,
  setIsUnauhtError
) => {
  if (error.response) {
    if (error.response.status === 404) {
      setErrorMessages(["Request failed: Not found"])
      setIserror(true)
      setIserrorShow(true)
    } else if (error.response.status === 400) {
      setErrorMessages(["Request failed: " + (error.response.data.description? error.response.data.description : "Bad request")])
      setIserror(true)
      setIserrorShow(true)
    } else if (error.response.status === 403) {
      setErrorMessages([
        "Request failed: " +
          (error.response.data.description
            ? error.response.data.description
            : "Forbidden"),
      ])
      setIserror(true)
      setIserrorShow(true)
    } else if (error.response.status === 401) {
      setErrorMessages([])
      setIserror(true)
      setIserrorShow(false)
      setIsUnauhtError(true)
    } else if (error.response.status === 405) {
      setErrorMessages(["Request failed: Method not allowed"])
      setIserror(true)
      setIserrorShow(true)
    } else {
      setErrorMessages(["Request failed: " + error.response.status])
      setIserror(true)
      setIserrorShow(true)
    }
  } else if (error.request) {
    console.log("Request Error", error.request)
  } else {
    console.log("Error message", error.message)
  }
}
